module.exports = __webpack_public_path__ + "readmeTemplates/OSH_assembly.898b3cdd94d20d30828d610ab6138ebb.md";